export default __webpack_public_path__ + "static/media/a020-market-1.98676827.svg";